module.exports = __webpack_public_path__ + "img/60.3fa55801.jpg";